import { httpClient } from './http-client';

/**
 * Jev (TypeSafe) auto-categorisation, issue #26.
 *
 * The key is write-only: `saveSettings` can send it, nothing ever returns it.
 * The server reports only its last four characters and when it was set.
 */
export interface JevSettings {
  enabled: boolean;
  has_key: boolean;
  key_last4?: string;
  key_set_at?: string;
  /** Confidence at or above which Jev's choice is applied without review. */
  threshold: number;
  /** Transactions sent to Jev per rolling 24 hours. */
  daily_cap: number;
}

export interface JevSettingsResponse {
  settings: JevSettings;
  used_today: number;
  remaining_today: number;
}

export interface JevSettingsUpdate {
  api_key?: string;
  enabled?: boolean;
  threshold?: number;
  daily_cap?: number;
}

export interface AutoCategorizeResult {
  dry_run: boolean;
  rules_applied: number;
  applied: number;
  suggested: number;
  skipped: number;
  sent: number;
  more: boolean;
  cap_reached: boolean;
  by_category: Record<string, number>;
  error?: string;
}

export interface CategorySuggestion {
  transaction_id: string;
  date: string;
  description: string;
  amount: string;
  account_name: string;
  top1_category_id: string;
  top1_category_name: string;
  p1: string;
  top2_category_id?: string;
  top2_category_name?: string;
  p2?: string;
  created_at: string;
}

export const jevService = {
  getSettings: () => httpClient.get<JevSettingsResponse>('/ai/jev'),
  saveSettings: (u: JevSettingsUpdate) => httpClient.put<JevSettingsResponse>('/ai/jev', u),
  removeKey: () => httpClient.delete<JevSettingsResponse>('/ai/jev'),
  autoCategorize: (opts: { dry_run?: boolean; since?: string; limit?: number } = {}) =>
    httpClient.post<AutoCategorizeResult>('/transactions/auto-categorize', opts),
  listSuggestions: () =>
    httpClient.get<{ suggestions: CategorySuggestion[]; total: number }>('/transactions/category-suggestions'),
  acceptSuggestion: (transactionId: string, categoryId?: string) =>
    httpClient.post<{ transaction_id: string; category_id: string }>(
      `/transactions/category-suggestions/${transactionId}/accept`,
      categoryId ? { category_id: categoryId } : {},
    ),
};
